var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aPullc",on:{"click":function($event){return _vm.toApp()}}},[_c('img',{attrs:{"src":require("./images/bg.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }